import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../../config/axios';
import { Button } from '../../components/Atoms';
import AuthShell, { AuthLabel, AuthError, AuthSuccess, authInputStyle } from './AuthShell';

/**
 * ForgotPassword - input email + wysyłka linku resetującego.
 * Backend zwraca generic response (email enumeration prevention).
 */

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/forgot-password', { email });
      setSuccess(res.data.message || 'Jeśli adres istnieje, wysłaliśmy link do resetu hasła.');
    } catch (err) {
      setError(err.response?.data?.error || 'Nie udało się wysłać emaila. Spróbuj ponownie.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthShell
        eyebrow="Sprawdź skrzynkę"
        title={<>Wysłaliśmy <span style={{ fontStyle: 'italic', color: 'var(--t-sage)' }}>link</span>.</>}
        subtitle="Jeśli adres znajduje się w naszej bazie — link do resetu hasła czeka w skrzynce. Ważny godzinę."
        footer={
          <div style={{ fontSize: 13, color: 'var(--t-text-dim)' }}>
            <Link to="/login" style={{
              color: 'var(--t-sage)', textDecoration: 'none', fontWeight: 500,
            }}>← Wróć do logowania</Link>
          </div>
        }
      >
        <AuthSuccess>{success}</AuthSuccess>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      eyebrow="Reset hasła"
      title={<>Pomożemy <span style={{ fontStyle: 'italic', color: 'var(--t-sage)' }}>przypomnieć</span>.</>}
      subtitle="Podaj adres email z którym konto zostało zarejestrowane. Wyślemy link do utworzenia nowego hasła."
      footer={
        <div style={{ fontSize: 13, color: 'var(--t-text-dim)' }}>
          <Link to="/login" style={{
            color: 'var(--t-sage)', textDecoration: 'none', fontWeight: 500,
          }}>← Wróć do logowania</Link>
        </div>
      }
    >
      <form onSubmit={handleSubmit} noValidate>
        <AuthError>{error}</AuthError>

        <div style={{ marginBottom: 22 }}>
          <AuthLabel htmlFor="email">Email</AuthLabel>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="twoj@email.com"
            style={authInputStyle}
            autoFocus
          />
        </div>

        <Button
          type="submit"
          full
          variant={loading || !email ? 'ghost' : 'primary'}
        >{loading ? 'Wysyłam…' : 'Wyślij link resetujący'}</Button>
      </form>
    </AuthShell>
  );
}
